function legacyCopyText(text) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  textarea.style.left = '-9999px';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);
  return copied;
}

export async function writeTextToClipboard(text) {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const copied = legacyCopyText(text);
  if (!copied) {
    throw new Error('Clipboard write failed');
  }
}

export async function readTextFromClipboard() {
  if (navigator.clipboard?.readText && window.isSecureContext) {
    const text = await navigator.clipboard.readText();
    if (typeof text === 'string') return text;
  }

  throw new Error('Clipboard read is unavailable');
}
